import Header from "../Header/Header";
import { Layout } from "../Layout/Layout";
import { AddTeam } from "./Modal/AddTeam";
import Swal from 'sweetalert2'
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { Edit, RemoveRedEye } from "@mui/icons-material";
import { DataTableComp } from "../Common/DataTable";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function Team() {
    const [teams, setTeams] = useState([]);
    const [editId, setEditId] = useState(0);
    const [popupType, setPopupType] = useState('Add');
    const navigate = useNavigate()

    const [show, setShow] = useState(false);
    useEffect(() => {
        getTeams()
    }, [])

    const getTeams = () => {
        axios.get(`/api/teams`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setTeams(result.data)
            }
        })
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            showCancelButton: true,
            confirmButtonColor: '#45a7c4',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) { 
                axios.delete(`/api/team?id=${id}`).then((res) =>{
                    if(res.data.success){                             
                        Swal.fire('Deleted!', '', 'success')
                        getTeams();
                    } 
                }).catch((error) => {
                    console.log(error);                     
                    Swal.fire(error.message, '', 'info')           
                });
            } else if (result.isDenied) {
              Swal.fire('Cancelled!', '', 'info')
            }
        }) 
    }

    const handleAdd = () => {
        setEditId(0);
        setPopupType('Add');
        setShow(true);
    }
    const handleEdit = (id) => {
        setEditId(id);
        setPopupType('Edit');
        setShow(true);
    }

    const handleView = (id, name) => {
        navigate('/assessments?id='+id+'&name='+name)        
    }

    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        // {
        //     name: 'Status',
        //     cell: row => (
        //        <Switch className="Rj-toggle" {...label} defaultChecked color="info" />                
        //     ),
        //     wrap: true
        // },
        {
            name: 'Action',
            cell: row => (
                <>
                    <Tooltip title="View Assessments" size='small' className='icon icon-sm icon-secondary' onClick={() => handleView(row.id, row.name)}>
                        <IconButton>
                            <RemoveRedEye />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit" size='small' className='icon icon-sm icon-secondary ms-2' onClick={() => handleEdit(row.id)}>
                        <IconButton>
                             <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip onClick={() => handleDelete(row.id)} title="Delete" size='small' className='icon icon-sm icon-primary ms-2'>
                        <IconButton>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </>
                
            )
        },
    ];

    return(
        <Layout>
            <Header pageTitle="Organizations" />
            <div className="container-xxl flex-grow-1 container-p-y">            
                <div className="">
                    <div className="card-header ">
                        <div className="row align-items-center">                    
                            <div className="col-lg-8 col-md-4 col-xs-12 mb-Rg-3">
                                <h3 className="fw-bold mb-0">Organizations</h3>
                            </div>                               
                            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 text-md-end">                                
                                    <button type="button" className="btn btn-primary" onClick={handleAdd}>
                                    <span className="tf-icons bx bx-plus"></span>&nbsp; Add Organization
                                </button>                               
                            </div>                           
                        </div>                        
                    </div>
                    <div className="table text-nowrap">
                        <div className="">
                            <DataTableComp columns={columns} data={teams} isIndex={true} />                            
                        </div>
                    </div>
                </div>
            </div>
            <AddTeam editId={editId} setEditId={setEditId} getTeams={getTeams} type={popupType} show={show} setShow={setShow}/>
        </Layout>
    )
}